import getISOWeek from 'date-fns/getISOWeek'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type isoWeekType = (date: dateParamType) => number

const isoWeek: isoWeekType = (dateProp) => {
  const date = toDate(dateProp)
  return getISOWeek(date)
}

export default isoWeek
